export const PaymentIcon = ({ ...rest }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#7C3AED"
        fillOpacity="0.1"
      />
      <path
        d="M26.6667 14.1667H13.3333C12.4129 14.1667 11.6667 14.9128 11.6667 15.8333V24.1667C11.6667 25.0871 12.4129 25.8333 13.3333 25.8333H26.6667C27.5871 25.8333 28.3333 25.0871 28.3333 24.1667V15.8333C28.3333 14.9128 27.5871 14.1667 26.6667 14.1667Z"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 18.3333H28.3333"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
